import { render, staticRenderFns } from "./indexDetail.vue?vue&type=template&id=1ac0a2ca&scoped=true"
import script from "./indexDetail.vue?vue&type=script&lang=js"
export * from "./indexDetail.vue?vue&type=script&lang=js"
import style0 from "./indexDetail.vue?vue&type=style&index=0&id=1ac0a2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0a2ca",
  null
  
)

export default component.exports